// 초 단위를 받아서 mm:ss.ms 형식과 6자리 숫자형을 함께 반환
export function formatTime(seconds) {
  if (isNaN(seconds)) {
    return {
      pretty: "00:00.00",
      compact: "000000",
    };
  }

  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  const ms = Math.floor((seconds % 1) * 100); // 소수점 → ms

  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  const mss = String(ms).padStart(2, "0");

  // "mm:ss.ms" 포맷
  const pretty = `${mm}:${ss}.${mss}`;

  // ":" "." 제거 → "000000" 형식
  const compact = `${mm}${ss}${mss.slice(0, 2)}`; // ms 앞 2자리만 써서 6자리 유지

  return { pretty, compact };
}
